import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-solid-svg-icons'

import { Button } from '@domain-group/suit-theme'

type DownloadButtonParams = {
  links: {
    original_url?: string,
    thumb_url?: string,
  },
}

const DownloadButton = (params: DownloadButtonParams) => {
  const { links } = params

  return (
    <Button
      // @ts-expect-error TS2322
      as="a"
      buttonStyle="secondaryEdit"
      fontSize="14px"
      href={links?.original_url}
      icon={<FontAwesomeIcon icon={faDownload} />}
      marginTop="small"
      rel="noopener noreferrer"
      target="_blank"
      padding="10px"
    >
      Download File
    </Button>
  )
}

export default DownloadButton
